import React from 'react';
import {useState} from 'react'
import {useDispatch} from "react-redux"
import { showChangePhonePopUp } from '../actions';
import { updateCounsellorPhone } from 'service/api';
import { showMessage } from 'modules/messages/actions';
import { useForm } from "react-hook-form";

import { failedMessage, invalidPhoneMessage, phoneRegex, phoneSuccessMessage } from 'service/constants';
import close from 'assets/img/close.svg'
import {Button} from 'material-ui'
import FontAwesomeIcon from "@fortawesome/react-fontawesome"
import { faSpinner } from '@fortawesome/fontawesome-free-solid'
import FormInput from 'ui-components/FormInput';

import './change-phone.scss'


const ChangePhonePopUp = () => {
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)

    const {
        register,
        formState: { errors },
        handleSubmit,
        reset,
        watch
    } = useForm({
        mode: "onSubmit",
        reValidateMode: 'onChange',
        defaultValues: {
            phone: "+1"
        }
    });

    const closeHandler = () => dispatch(showChangePhonePopUp())

    const onSubmit = async ({phone}) => {
        try {
            setLoading(true)
            await updateCounsellorPhone(phone)
            dispatch(showMessage(phoneSuccessMessage))
            reset()
            setTimeout(() => closeHandler(), 100) 
        } catch(e) {
            console.log(e)
            dispatch(showMessage(failedMessage))
        } finally {
            setLoading(false)
        }
    }

    const phone = watch("phone")
    const isBtnDisabled = loading || !phone || errors.phone
    return (
        <div className='change-phone'>
            <form onSubmit={handleSubmit(onSubmit)}>
                <button 
                    className="icon-button close-button"
                    onClick={closeHandler}
                    type="button"
                >
                    <img className="close-button" src={close} alt="close-button"/>
                </button>
                <div className="form-wrapper">
                    <h2 className="form-head">Change Phone</h2>
                    <FormInput
                        title={"New phone"}
                        name={"phone"}
                        register={register}
                        errors={errors}
                        invalidMessage={invalidPhoneMessage}
                        pattern={phoneRegex}
                        isPhone={true}
                    /> 
                    <Button
                        color="secondary" 
                        variant="raised" 
                        className="submit-button"
                        type="submit"
                        disabled={isBtnDisabled}
                    >
                        { loading ? <FontAwesomeIcon icon={faSpinner} spin /> : "Submit"}
                    </Button>
                        
                </div>
                
            </form>
        </div>
    );
};

export default ChangePhonePopUp;